.code-snippet {
  margin: 10px 0;
}

.code-snippet__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background-color: var(--biel-code-snippet-header-bg-color);
  font-size: var(--biel-code-snippet-font-size);
  color: var(--biel-code-snippet-header-text-color);
  border-radius: 6px 6px 0px 0px;
}

.copy-button {
  background: none;
  border: none;
  color: var(--biel-code-snippet-header-text-color);
  cursor: pointer;
  font-size: var(--biel-code-snippet-font-size);
  display: flex;
  align-items: center;
}

.copy-button svg {
  margin-right: 5px;
}

.copy-button:focus {
  outline: none;
}

.copy-button__container {
  display: flex;
  align-items: center;
}

.code-snippet__content {
  padding: 10px;
  color: var(--biel-code-snippet-content-text-color);
  background-color: var(--biel-code-snippet-content-bg-color);
  border-radius: 0px 0px 6px 6px;
  overflow-x: auto;
  margin: 0;
  font-family: var(--biel-code-snippet-font-family);
}

.code-snippet__content::-webkit-scrollbar {
  height: 8px;
}

.code-snippet__content::-webkit-scrollbar-thumb:horizontal {
  background-color: var(--biel-chat-scrollbar-color);
  border-radius: var(--biel-radius-md);
  border: 3px solid transparent;
}

.code-snippet__content::-webkit-scrollbar-thumb:hover {
  background-color: var(--biel-chat-scrollbar-hover-color);
}

/*!
  Theme: GitHub Dark
  Description: Dark theme as seen on github.com
  Author: github.com
  Maintainer: @Hirse
  Updated: 2021-05-15

  Outdated base version: https://github.com/primer/github-syntax-dark
  Current colors taken from GitHub's CSS
*/

.hljs {
  color: #c9d1d9;
}

.hljs-doctag,
.hljs-keyword,
.hljs-meta .hljs-keyword,
.hljs-template-tag,
.hljs-template-variable,
.hljs-type,
.hljs-variable.language_ {
  color: #ff7b72
}

.hljs-title,
.hljs-title.class_,
.hljs-title.class_.inherited__,
.hljs-title.function_ {
  color: #d2a8ff
}

.hljs-attr,
.hljs-attribute,
.hljs-literal,
.hljs-meta,
.hljs-number,
.hljs-operator,
.hljs-variable,
.hljs-selector-attr,
.hljs-selector-class,
.hljs-selector-id {
  color: #79c0ff
}

.hljs-regexp,
.hljs-string,
.hljs-meta .hljs-string {
  color: #a5d6ff
}

.hljs-built_in,
.hljs-symbol {
  color: #ffa657
}

.hljs-comment,
.hljs-code,
.hljs-formula {
  color: #8b949e
}

.hljs-name,
.hljs-quote,
.hljs-selector-tag,
.hljs-selector-pseudo {
  color: #7ee787
}

.hljs-subst {
  color: #c9d1d9
}

.hljs-section {
  color: #1f6feb;
  font-weight: bold
}

.hljs-bullet {
  color: #f2cc60
}

.hljs-emphasis {
  color: #c9d1d9;
  font-style: italic
}

.hljs-strong {
  color: #c9d1d9;
  font-weight: bold
}

.hljs-addition {
  color: #aff5b4;
}

.hljs-deletion {
  color: #ffdcd7;
}